import { setURL } from '@/api/apiUtil'

export default {
  // 社區服務管理
  /**
   * 取得郵件包裹列表
   * test OK
   */
  getMailPackageList: {
    url: (communityId) =>
      setURL('/mail-package/community/:communityId', { communityId }),
    method: 'get'
  },
  /**
   * 根據郵件包裹編號取得郵件包裹詳細資訊
   */
  getMailPackageInfo: {
    url: (mailPackageId) =>
      setURL('/mail-package/info/:mailPackageId', { mailPackageId }),
    method: 'get'
  },
  /**
   * 新增郵件包裹收件
   */
  addMailPackage: {
    url: setURL('/mail-package'),
    method: 'post'
  },
  /**
   * 根據郵件包裹編號修改郵件包裹資訊
   */
  updateMailPackage: {
    url: (mailPackageId) =>
      setURL('/mail-package/:mailPackageId', { mailPackageId }),
    method: 'put'
  },
  /**
   * 郵件包裹退貨申請
   * test OK
   */
  returnMailPackage: {
    url: (mailPackageId) =>
      setURL('/mail-package/return/:mailPackageId', { mailPackageId }),
    method: 'put'
  },
  /**
   * 郵件包裹退貨完成
   * test OK
   */
  returnCompleteMailPackage: {
    url: (mailPackageId) =>
      setURL('/mail-package/return/complete/:mailPackageId', { mailPackageId }),
    method: 'put'
  },
  /**
   * 領取郵件包裹
   * test OK
   */
  pickupMailPackage: {
    url: (mailPackageId) =>
      setURL('/mail-package/pickup/:mailPackageId', { mailPackageId }),
    method: 'put'
  },

  /**
   * 根據社區編號取得未領取郵件包裹列表
   */
  getUnclaimedMailPackageList: {
    url: (communityId) =>
      setURL('/mail-package/unclaimed/community/:communityId', { communityId }),
    method: 'get'
  },
  /**
   * 發送郵件包裹推播通知
   */
  sendNotification: {
    url: setURL('/mail-package/notification'),
    method: 'post'
  },
  /**
   * UI 新增/編輯
   * 下拉選單的資料
   */
  // 取得郵件包裹種類列表
  getMailPackageTypeList: {
    url: setURL('/mailPackageType'),
    method: 'get'
  },
  // 取得物流公司列表
  getLogisticsCompanyList: {
    url: setURL('/logisticsCompany'),
    method: 'get'
  },
  // 取得放置位置列表
  getLocationList: {
    url: setURL('/location'),
    method: 'get'
  },
  // 根據個人郵件包裹條碼取得郵件包裹資訊
  getMailPackageInfoByBarcode: {
    url: (barcode) =>
      setURL('/mail-package/personalBarcode/:barcode/info', { barcode }),
    method: 'get'
  },
  // 根據個人郵件包裹條碼領取郵件包裹
  pickupMailPackageByBarcode: {
    url: (barcode) =>
      setURL('/mail-package/pickup/personalBarcode/:barcode', { barcode }),
    method: 'put'
  },
  // 根據個人郵件包裹條碼退貨申請郵件包裹
  returnMailPackageByBarcode: {
    url: (barcode) =>
      setURL('/mail-package/return/personalBarcode/:barcode', { barcode }),
    method: 'put'
  },
}
